<div class="map-inner parking-lotmap custom-line">
    <p-chart type="bar" [data]="parkingLotsData" [options]="chartOptions"></p-chart>
</div>